import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import Staffs from '../views/Staffs.vue';
import YanfeiLiu from '../views/YanfeiLiu.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: 'Home - Fusion Intelligence' },
  },
  { 
    path: '/research',
    name: 'Research', 
    component: { template: '<div>Our Research</div>' }, 
    meta: { title: 'Research - Fusion Intelligence' }
  },
  { 
    path: '/staffs', 
    ame: 'Staffs', 
    component: Staffs,
    meta: { title: 'Staffs - Fusion Intelligence' },
  },
  { path: '/yanfei', 
    name: 'YanfeiLiu', 
    component: YanfeiLiu,
    meta: { title: 'Yanfei Liu - Fusion Intelligence' },
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
